import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { createStore, applyMiddleware } from 'redux';
import { getUrlParam, checkLocale } from './helpers';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { persistStore, persistReducer } from 'redux-persist';
import Reducers from './redux/reducers'
import thunk from 'redux-thunk';
import Locales from './i18n';
import storage from 'redux-persist/es/storage';
import Routes from './routes';

const config = {
  key: 'nixi1-webview',
  storage,
  blacklist: [
    'flightSearchReducer',
    'flightResultsReducer',
    'hotelsSearchReducer',
    'hotelsResultsReducer',
    'shareReducers',
    'i18n',
    'passengerInfoReducer',
    'passengers',
    'info'
  ]
}

const reducers = persistReducer(config, Reducers);

const store = createStore(reducers, applyMiddleware(thunk));
const translationsObject = Locales;
const locale = checkLocale(getUrlParam('lang'));

syncTranslationWithStore(store)
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale(locale));

const persistor = persistStore(store);

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <main>
          {/* <Header /> */}
          <div className="nixi1-webview">
            <Routes />
          </div>
        </main>
      </PersistGate>
    </Provider>
  )
}